/* eslint-disable no-restricted-globals */

import * as React from 'react';
import PacklinkAuthForm from './packlink_auth_form';
import PacklinkCreateDraft from './packlink_create_draft';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import {
  CorePacklinkAccount,
  core_apimessages_PacklinkAccount_Status as PacklinkAccountStatus,
} from '../schemas/rql';


interface ExternalProps {
  onAuthSuccess?(): void;
  onDraftSuccess?(): void;
  orderId?: string;
  order?: any;
}

type Props = ChildProps<ExternalProps, CorePacklinkAccount.Query>;

export function PacklinkAuthorizeAccountOrCreateDraft(props: Props) {
  const {
    onAuthSuccess,
    onDraftSuccess,
    orderId,
    order,
    data,
  } = props;
  const hasActiveAccount = data?.me?.shop?.packlink?.account?.status === PacklinkAccountStatus.COMPLETED;

  if (hasActiveAccount && orderId) {
    return (
      <PacklinkCreateDraft
        onDraftSuccess={onDraftSuccess}
        orderId={orderId}
        order={order}
      />
    );
  }

  if (!data?.loading) {
    return <PacklinkAuthForm onAuthSuccess={onAuthSuccess} />;
  }

  return null;
}


const withQuery = graphql<ExternalProps, {}>(
  gql`
  query Core_Packlink_Account {
    me {
      shop {
        packlink {
          account {
            status
          }
        }
      }
    }
  }`,
);

export default withQuery(PacklinkAuthorizeAccountOrCreateDraft);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/packlink_authorize_account_or_create_draft.tsx